import { FC } from "react";
import clsx from "clsx";

interface ArrowNavigationSkeletonProps {
  className?: string;
}

const ArrowNavigationSkeleton: FC<ArrowNavigationSkeletonProps> = ({ className }) => {
  return (
    <div className={clsx("flex items-center gap-2", className)}>
      {/* Pagination numbers skeleton */}
      <div className="flex items-center gap-2">
        {/* Simulate 4 page numbers/dots */}
        {[1, 2, 3, 4].map((index) => (
          <div
            key={index}
            className="h-6 w-6 rounded-lg bg-gray-200 animate-pulse me-2"
          />
        ))}
      </div>

      {/* Arrow buttons skeleton */}
      {[1, 2].map((index) => (
        <div
          key={index}
          className="w-10 h-10 rounded-full bg-gray-200 animate-pulse me-2"
        />
      ))}
    </div>
  );
};

export default ArrowNavigationSkeleton;